import type { NuxtApp } from '#app';

/**
 * Plugin for initializing baseStore and language information.
 */
export default defineNuxtPlugin({
  name: 'init-base-store',
  dependsOn: ['pinia', 'i18n:plugin'],
  parallel: true,
  async setup(_nuxtApp) {
    const { $config, $i18n, $pinia } = _nuxtApp as NuxtApp;
    const langCookie = unref(useCookie('i18n_redirected'));

    const { origin, hostname, pathname } = useRequestURL();
    const { baseStore, baseStoreConfig, isMultilang, isocodes, language } = getBaseStoreData(
      hostname,
      pathname,
      $config,
      langCookie,
    );

    // Catch missing values early to prevent cascades of errors
    assertHasValues({ baseStore, baseStoreConfig, origin, hostname, isocodes, language, pathname });

    // Using pinia to hydrate
    if (import.meta.server) {
      useMainStore($pinia).$patch({
        baseStore,
        baseStoreConfig,
        language,
        isMultilang,
        isAppview: unref(useIsAppView()),
      });
    }

    await $i18n.setLocale(language as string);

    // TODO: At some point, these helpers should be moved into our pinia store - no need to inject them globally!
    return {
      provide: {
        domain: hostname,
        host: origin,
        isocodes,
      },
    };
  },
});
